<template>
<div class="modal verify-password-modal"
     :class="{ 'is-active': isShown }"
>
    <div class="modal-background" @click="closeModal"></div>
    <div class="modal-card">

        <header class="modal-card-head">
            <p class="modal-card-title">
                {{ titleText }}
            </p>
            <button
                class="delete"
                aria-label="close"
                :disabled="isLoading"
                @click="closeModal"
            ></button>
        </header>

        <section class="modal-card-body">
            <div class="content">
                {{ contentText }}
            </div>
        </section>

        <footer class="modal-card-foot">
            <div v-if="!isSuccess">
                <button
                    class="button is-info"
                    :class="{ 'is-loading': isAccepting }"
                    :disabled="isLoading"
                    @click="accept"
                >
                    {{ trans.accept_button }}
                </button>
                <button
                    class="button is-danger is-outlined"
                    :class="{ 'is-loading': isDeclining }"
                    :disabled="isLoading"
                    @click="decline"
                >
                    {{ trans.decline_button }}
                </button>
                <p v-show="errors.unexpected" class="help is-danger">
                    {{ errors.unexpected }}
                </p>
            </div>
            <div v-else>
                <div
                    class="content has-text-success"
                    v-if="isAccepting"
                >
                    {{ trans.accepted_text }}
                </div>
                <div
                    class="content has-text-danger"
                    v-if="isDeclining"
                >
                    {{ trans.declined_text }}
                </div>
            </div>
        </footer>
    </div>
</div>
</template>

<script>
    import { axiosForm } from '../../mixins/axiosFormMixin';
    import { mapState, mapActions } from 'vuex';

    export default {
        name: "BaseInviteAcceptModal",
        mixins: [axiosForm],
        props: {
            actions: Object,
            acceptRedirect: String,
            declineRedirect: String,
            specificBase: {
                default: null
            },
        },
        data() {
            return {
                isAccepting: false,
                isDeclining: false,
                isSuccess: false,
            };
        },
        methods: {
            ...mapActions('baseInviteAccept',
                {
                    showModal: 'showBaseInviteAcceptModal',
                    hideModal: 'hideBaseInviteAcceptModal',
                }
            ),
            /**
             * Обработчик закрытия модального окна
             */
            closeModal() {
                if (this.isLoading) {
                    return;
                }

                if (this.specificBase) {
                    this.redirectAfter();
                    return;
                }

                this.hideModal();
            },

            /**
             * Финальный редирект
             */
            redirectAfter() {
                let redirectUrl = this.isAccepting
                    ? this.insertHash(this.acceptRedirect)
                    : this.declineRedirect;

                window.location.replace(redirectUrl);
            },

            /**
             * Нажатие кнопки принятия приглашения
             * @param e
             */
            accept(e) {
                let endpoint = this.insertHash(this.actions.accept);
                this.isAccepting = true;
                this.submit(e, endpoint);
            },

            /**
             * Нажатие кнопки отклонения приглашения
             * @param e
             */
            decline(e) {
                let endpoint = this.insertHash(this.actions.decline);
                this.isDeclining = true;
                this.submit(e, endpoint);
            },

            /**
             * Функция вставки hash_id базы в url
             * @param url
             * @returns {*}
             */
            insertHash(url) {
                return this.replaceWildcards(url, {
                    base_hash: this.base.hash_id
                });
            },

            /**
             * Обработчик ответа сервера
             * @param response
             */
            postResultHandler(response) {
                if (response.data.accepted || response.data.declined) {
                    this.isSuccess = true;

                    this.redirectAfter();
                }
            },

            /**
             * Обработчик ошибок сервера
             * @param response
             */
            postErrorHandler(response) {
                this.errors.unexpected = this.trans.unexpected_error;
            },

            /**
             * Вставка имени базы в текст
             * @param text
             * @returns {*}
             */
            insertBaseName(text) {
                if (this.base) {
                    return this.replaceWildcards(text, {
                        base_name: this.base.name,
                    });
                }
            }
        },
        computed: {
            ...mapState('baseInviteAccept', [
                'isShown',
                'base',
            ]),
            titleText() {
                return this.insertBaseName(this.trans.title);
            },
            contentText() {
                return this.insertBaseName(this.trans.content_text);
            }
        },
        watch: {
            isAccepting() {
                this.isLoading = true;
            },
            isDeclining() {
                this.isLoading = true;
            },
        },
        mounted () {
            if (this.specificBase) {
                this.showModal(this.specificBase);
            }
        }
    }
</script>
